import { render, staticRenderFns } from "./03Words.vue?vue&type=template&id=435ad66a&"
import script from "./03Words.vue?vue&type=script&lang=js&"
export * from "./03Words.vue?vue&type=script&lang=js&"
import style0 from "./03Words.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports